import { pixelIcons, type PixelIconName } from '@/game/pixelIcons'

interface PixelIconProps {
  name: PixelIconName | string
  size?: number
  className?: string
  title?: string
}

export function PixelIcon({ name, size = 24, className, title }: PixelIconProps) {
  const icon = pixelIcons[name as PixelIconName]
  if (!icon) return null
  return (
    <svg
      width={size}
      height={size}
      viewBox={icon.viewBox}
      fill="none"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      dangerouslySetInnerHTML={{ __html: icon.path }}
    />
  )
}
